global.version = "1.1.0";
global.menu = [
    { title: "Main" },
    { name: "Dashboard", icon: "", link: "/dashboard", type: "", permission: "dashboard.read" },

    { title: "Payment" },
    { name: "Deposit", icon: "", link: "/deposits-withdrawals", type: "deposits", permission: "deposits.read" },
    { name: "Withdrawal", icon: "", link: "/deposits-withdrawals", type: "withdrawals", permission: "withdrawals.read", component: <span id="badge-withdrawals"></span> },
    { name: "Mismatch", icon: "", link: "/mismatchs", type: "", permission: "mismatchs.read", component: <span id="badge-mismatchs"></span> },
    { name: "Settlement HQ", icon: "", link: "/settlements-hq", type: "", permission: "settlements-hq.read", component: <span id="badge-settlements-hq"></span> },

    { title: "Management" },
    { name: "User", icon: "", link: "/users", type: "", permission: "users.read" },
    { name: "Agents", icon: "", link: "/agents", type: "", permission: "agents.read" },
    { name: "Brokers", icon: "", link: "/brokers", type: "", permission: "brokers.read" },
    { name: "Customers", icon: "", link: "/customers", type: "", permission: "customers.read" },

    { title: "Reports" },
    { name: "Settlement Report", icon: "", link: "/settlements", type: "", permission: "settlements.read" },
    { name: "Monthly Report", icon: "", link: "/monthlies", type: "", permission: "monthlies.read" },
    { name: "Annual Report", icon: "", link: "/annual-profits", type: "", permission: "annual-profits.read" },
    { name: "Gateway Report", icon: "", link: "/gateway-reports", type: "", permission: "gateway-reports.read" },
    // { name: "GMV Usage", icon: "", link: "/gateway-gmv-usage", type: "", permission: "brokers.read" },
    { name: "Transfer Money Report", icon: "", link: "/transfer-moneys", type: "", permission: "transfer-moneys.read" },
    { name: "Invoice Report", icon: "", link: "/invoices", type: "", permission: "invoices.read" },
    { name: "Transaction Analytics", icon: "\uf201", link: "/transaction-analytics", type: "", permission: "transaction-analytics.read" },
    { name: "GMV Analytics", icon: "\uf3fd", link: "/gmv-monitor", type: "", permission: "gmv-monitor.read" },
    { name: "Flow Map", icon: "", link: "/flow-map", type: "", permission: "gateway-reports.read" },
    // { name: "Reconcile", icon: "", link: "/reconciles", type: "", permission: "reconciles.read" },

    { title: "Commission" },
    { name: "Commission Agent", icon: "", link: "/commission-agents", type: "", permission: "commission-agents.read" },
    { name: "Commission Dev", icon: "", link: "/monthly-devs", type: "", permission: "monthly-devs.read" },

    { title: "Monitoring" },
    { name: "Logs Request", icon: "", link: "/logs", type: "", permission: "logs.read" },
    { name: "Logs Webhook", icon: "", link: "/webhooks", type: "", permission: "webhooks.read" },
    { name: "Order Marketplace", icon: "", link: "/order-marketplace", type: "", permission: "order-marketplace.read" },
    { name: "Product Marketplace", icon: "", link: "/products", type: "", permission: "products.read" },
    // { name: "CFR Verification", icon: "", link: "/cfr-accounts", type: "", permission: "cfr-accounts.read" },
    // super_user ได้ products.read จาก Navbar.filterMenu เสมอ role อื่นตั้งสิทธิ์ products.* ในหน้า Roles

    { title: "Configuration" },
    { name: "Center Config", icon: "", link: "/center-configs", type: "", permission: "center-configs.read" },
    { name: "Gateway", icon: "", link: "/gateway-rules", type: "", permission: "gateway-rules.read" },
    { name: "Holiday", icon: "", link: "/holidays", type: "", permission: "holidays.read" },
    { name: "Phonetic Map", icon: "", link: "/phonetic-maps", type: "", permission: "phonetic-maps.read" },
    { name: "Tier", icon: "", link: "/tier-configs", type: "", permission: "tier-configs.read" },

    { title: "Access & System" },
    { name: "Role", icon: "", link: "/roles", type: "", permission: "roles.read" },
    { name: "Telegram Room", icon: "", link: "/telegram-rooms", type: "", permission: "telegram-rooms.read" },
    { name: "Developer Mode", icon: "", link: "/developer-mode", type: "", permission: "developer-mode.read" },
];

global.chat_room = [
  { title: "main", list: [
    { label: "🪙SwiftGoldPay", value: "-1002762957099" },
    { label: "Parthenon Tech", value: "-1003958078376" },
    { label: "Demo", value: "-5210609114" },
  ] },
  { title: "broker", list: [
    { label: "Swiftgold x Xenith OP", value: "-5043340716" },
    { label: "SwiftGold x IUX OP", value: "-1003676198395" },
    { label: "SwiftGold x GOC l OP", value: "-1002987995993" },
  ] },
]

global.gateway_company = [
  { value: "ZenithLink", label: "ZenithLink" },
  { value: "LucidIntelligence", label: "LucidIntelligence" },
  { value: "Levelup", label: "Levelup" },
  { value: "MeridianDynamics", label: "MeridianDynamics" },
  { value: "NivoraVentures", label: "NivoraVentures" },
];

global.business_type = [
  { value: "CRM-Package", label: "CRM-Package" },
  { value: "E-Commerce", label: "E-Commerce" },
  { value: "Game-Online", label: "Game-Online" },
];

global.bank = [
  { icon: "BNP.png", value: "BNP", label: "BNP Paribas Bangkok Branch", name_th: "", code: "030",},
  { icon: "MHBC.png", value: "MHBC", label: "Mizuho Corporate Bank", name_th: "", code: "031",},
  { icon: "DEUTSHE.png", value: "DEUTSHE", label: "Deutsche Bank AG.", name_th: "", code: "032",},
  { icon: "CGC.png", value: "CGC", label: "Credit Agricole Corporate and Investment Bank", name_th: "", code: "033",},
  { icon: "BA.png", value: "BA", label: "Bank of America National Association", name_th: "", code: "034",},
  { icon: "MEGAICBC.png", value: "MEGAICBC", label: "Mega International Commercial Bank", name_th: "", code: "039",},
  { icon: "SCBT.png", value: "SCBT", label: "Standard Chartered Bank", name_th: "", code: "020",},
  { icon: "SMBC.png", value: "SMBC", label: "Sumitomo Mitsui Banking Corporation", name_th: "", code: "035",},
  { icon: "CITI.png", value: "CITI", label: "CITI Bank N.A.", name_th: "", code: "036",},
  { icon: "TMB.png", value: "TMB", label: "TMB Bank", name_th: "", code: "011",},
  { icon: "RBS.png", value: "RBS", label: "The Royal Bank of Scotland N.V.", name_th: "", code: "037",},
  { icon: "BOT.png", value: "BOT", label: "Bank of Thailand", name_th: "", code: "000",},
  { icon: "CIMB.png", value: "CIMB", label: "CIMB Thai", name_th: "ธนาคารซีไอเอ็มบีไทย", code: "022",},
  { icon: "LHB.png", value: "LHB", label: "Land and Houses Bank", name_th: "ธนาคารแลนด์แอนด์เฮ้าส์", code: "073",},
  { icon: "TCRB.png", value: "TCRB", label: "The Thai Credit Retail Bank", name_th: "ธนาคารไทยเครดิตเพื่อรายย่อย", code: "071",},
  { icon: "KKP.png", value: "KKP", label: "Kiatnakin Bank", name_th: "ธนาคารเกียรตินาคิน", code: "069",},
  { icon: "TISCO.png", value: "TISCO", label: "Tisco Bank", name_th: "ธนาคารทิสโก้", code: "067",},
  { icon: "IBANK.png", value: "IBANK", label: "Islamic Bank of Thailand", name_th: "ธนาคารอิสลามแห่งประเทศไทย", code: "066",},
  { icon: "HSBC.png", value: "HSBC", label: "Hong Kong & Shanghai Corporation", name_th: "ฮ่องกงและเซี่ยงไฮ้แบงกิ้งคอร์ปอเรชั่น", code: "030",},
  { icon: "UOB.png", value: "UOB", label: "United Overseas Bank", name_th: "ธนาคารยูโอบี (ไทย)", code: "024",},
  { icon: "ICBC.png", value: "ICBC", label: "Industrial and Commercial Bank of China Limited", name_th: "ธนาคารพาณิชย์อุตสาหกรรมแห่งประเทศจีน", code: "070",},
  { icon: "BAAC.png", value: "BAAC", label: "Bank for Agriculture and Agricultural Cooperatives", name_th: "ธ.ก.ส.", code: "034",},
  { icon: "GHB.png", value: "GHB", label: "Government Housing Bank", name_th: "ธนาคารอาคารสงเคราะห์", code: "033",},
  { icon: "GSB.png", value: "GSB", label: "Government Savings Bank", name_th: "ธนาคารออมสิน", code: "030",},
  { icon: "BAY.png", value: "BAY", label: "Bank of Ayudhya", name_th: "ธนาคารกรุงศรีอยุธยา", code: "025",},
  { icon: "KTB.png", value: "KTB", label: "Krung Thai Bank", name_th: "ธนาคารกรุงไทย", code: "006",},
  { icon: "BBL.png", value: "BBL", label: "Bangkok Bank", name_th: "ธนาคารกรุงเทพ", code: "002",},
  { icon: "TTB.png", value: "TTB", label: "TTB Thanachart Bank", name_th: "ธนาคารทหารไทยธนชาต", code: "011",},
  { icon: "KBANK.png", value: "KBANK", label: "Kasikorn Bank", name_th: "ธนาคารกสิกรไทย", code: "004",},
  { icon: "SCB.png", value: "SCB", label: "Siam Commercial Bank", name_th: "ธนาคารไทยพาณิชย์", code: "014",},

  { icon: "ACLE.png", value: "ACLE", label: "Acleda Bank Lao Co., Ltd", name_th: "", code: "",},
  { icon: "APB.png", value: "APB", label: "Agricultural Promotion Bank", name_th: "", code: "",},
  { icon: "BOC.png", value: "BOC", label: "Bank Of China", name_th: "", code: "",},
  { icon: "BFL.png", value: "BFL", label: "Banque Franco-Lao Co., Ltd", name_th: "", code: "",},
  { icon: "BCEL.png", value: "BCEL", label: "Banque Pour Le Commerce Exterieur Lao Public", name_th: "", code: "",},
  { icon: "BIC.png", value: "BIC", label: "Bic Bank Lao Co., Ltd", name_th: "", code: "",},
  { icon: "IDB.png", value: "IDB", label: "Indochina Bank Ltd", name_th: "", code: "",},
  { icon: "JDB.png", value: "JDB", label: "Joint Development Bank Public", name_th: "", code: "",},
  { icon: "LDB.png", value: "LDB", label: "Lao Development Bank", name_th: "", code: "",},
  { icon: "LVB.png", value: "LVB", label: "Lao-Viet Bank Co., Ltd", name_th: "", code: "",},
  { icon: "MJB.png", value: "MJB", label: "Maruhan Japan Bank Lao Co., Ltd", name_th: "", code: "",},
  { icon: "VMB.png", value: "VMB", label: "Military Commercial Joint Stock Bank - LAOS Branch", name_th: "", code: "",},
  { icon: "PSV.png", value: "PSV", label: "Phongsavanh Bank", name_th: "", code: "",},
  { icon: "PUBLIC.png", value: "PUBLIC", label: "Public Bank Lao", name_th: "", code: "",},
  { icon: "SACOM.png", value: "SACOM", label: "Sacom Bank Lao", name_th: "", code: "",},
  { icon: "STB.png", value: "STB", label: "St Bank Co., Ltd", name_th: "", code: "",},
  { icon: "VTB.png", value: "VTB", label: "Vietinbank Lao Limited", name_th: "", code: "",},
];

global.permission = [
  "deposits.read",
  "withdrawals.read",
  "settlements-hq.read",
  "users.read",
  "agents.read",
  "brokers.read",
  "customers.read",
  "monthlies.read",
  "settlements.read",
  "reconciles.read",
  "transfer-moneys.read",
  "mismatchs.read",
  "commission-agents.read",
  "invoices.read",
  "gateway-reports.read",
  "monthly-devs.read",
  "logs.read",
  "cfr-accounts.read",
  "tier-configs.read",
  "gateway-rules.read",
  "roles.read",
  "center-configs.read",
  "telegram-rooms.read",
  "phonetic-maps.read",
  "holidays.read",
  "certificates.read",
  "wallets.read",

  "deposits.create",
  "withdrawals.create",
  "settlements-hq.create",
  "users.create",
  "agents.create",
  "brokers.create",
  "customers.create",
  "monthlies.create",
  "settlements.create",
  "reconciles.create",
  "transfer-moneys.create",
  "mismatchs.create",
  "commission-agents.create",
  "invoices.create",
  "gateway-reports.create",
  "monthly-devs.create",
  "logs.create",
  "cfr-accounts.create",
  "tier-configs.create",
  "gateway-rules.create",
  "roles.create",
  "center-configs.create",
  "telegram-rooms.create",
  "phonetic-maps.create",
  "holidays.create",
  "certificates.create",
  "wallets.create",

  "deposits.update",
  "withdrawals.update",
  "settlements-hq.update",
  "users.update",
  "agents.update",
  "brokers.update",
  "customers.update",
  "monthlies.update",
  "settlements.update",
  "reconciles.update",
  "transfer-moneys.update",
  "mismatchs.update",
  "commission-agents.update",
  "invoices.update",
  "gateway-reports.update",
  "monthly-devs.update",
  "logs.update",
  "cfr-accounts.update",
  "tier-configs.update",
  "gateway-rules.update",
  "roles.update",
  "center-configs.update",
  "telegram-rooms.update",
  "phonetic-maps.update",
  "holidays.update",
  "certificates.update",
  "wallets.update",

  "deposits.delete",
  "withdrawals.delete",
  "settlements-hq.delete",
  "users.delete",
  "agents.delete",
  "brokers.delete",
  "customers.delete",
  "monthlies.delete",
  "settlements.delete",
  "reconciles.delete",
  "transfer-moneys.delete",
  "mismatchs.delete",
  "commission-agents.delete",
  "invoices.delete",
  "gateway-reports.delete",
  "monthly-devs.delete",
  "logs.delete",
  "cfr-accounts.delete",
  "tier-configs.delete",
  "gateway-rules.delete",
  "roles.delete",
  "center-configs.delete",
  "telegram-rooms.delete",
  "phonetic-maps.delete",
  "holidays.delete",
  "certificates.delete",
  "wallets.delete",

  "order-marketplace.read",
  "order-marketplace.create",
  "order-marketplace.update",
  "order-marketplace.delete",

  "webhooks.read",
  "webhooks.create",
  "webhooks.update",
  "webhooks.delete",

  "annual-profits.read",
  "annual-profits.create",
  "annual-profits.update",
  "annual-profits.delete",

  "transaction-analytics.read",
  "transaction-analytics.create",
  "transaction-analytics.update",
  "transaction-analytics.delete",
];

// ตารางรหัส response ในหน้า /document-api?i=response ตรงกับที่ PaymentBroker-ApiPartner ส่งจริง
// (config/global_message.js, config/helper.js, middleware/authorization.js) ถ้าเพิ่ม/เปลี่ยน code ฝั่ง API ให้แก้ที่นี่ด้วย
const responseRow = (response_code, code, message, data = null) => ({
  response_code,
  code,
  message,
  format_return: JSON.stringify({ status: { code, message }, data }, null, 2),
});

global.response = [
  responseRow("200", "S-2000", "Success", { token: "eyJhbGciOiJSUzI1NiI......", token_expires: "2025-06-12 16:37:00" }),
  responseRow("400", "D-4000", "Validate field"),
  responseRow("400", "C-4002", "Certificate invalid or expired / The IP address is not in the whitelist"),
  responseRow("400", "P-4003", "Data not found"),
  responseRow("400", "P-4004", "Duplicate data"),
  responseRow("400", "P-4005", "Gateway unavailable or transaction not found"),
  responseRow("400", "P-4006", "Broker data not found / Deposit or Withdrawal is temporarily disabled"),
  responseRow("400", "P-4007", "Bank data not found / Broker account is deactivated"),
  responseRow("400", "P-4008", "Amount is below the minimum or above the maximum"),
  responseRow("400", "P-4009", "Failed to register gateway"),
  responseRow("401", "P-4010", "Authorization header missing"),
  responseRow("401", "P-4011", "Invalid authentication format"),
  responseRow("401", "P-4012", "Token is required"),
  responseRow("400", "P-4013", "Token has expired"),
  responseRow("400", "P-4014", "Missing required header key"),
  responseRow("400", "P-4015", "Invalid format for required header key"),
  responseRow("400", "P-4016", "This customer still has a pending deposit transaction"),
  responseRow("401", "P-4017", "Invalid signature format"),
  responseRow("400", "P-4018", "Invalid or expired timestamp in the request"),
  responseRow("400", "P-4019", "Insufficient balance in the wallet"),
  responseRow("400", "P-4020", "Wallet data not found"),
  responseRow("400", "P-4022", "Transaction failed"),
  responseRow("429", "P-4029", "Too many requests. Next allowed at HH:mm:ss"),
  responseRow("400", "P-4031", "Customer account is blacklisted"),
  responseRow("400", "P-4032", "Gateway timeout, please retry."),
  responseRow("400", "P-4033", "Daily limit exceeded for this account"),
  responseRow("400", "P-4034", "Customer KYC required", { kyc_status: "none", kyc_url: "https://swiftgoldpay.com/kyc?t=eyJyZWYiOi..." }),
  responseRow("500", "IN-5000", "Internal Server Error"),
  responseRow("503", "S-5030", "Service is under maintenance. Please try again later."),
];

global.callback = `{
  "amount": "1.00",
  "amount_net": "0.99",
  "bank_account_name": "customers",
  "bank_account_number": "xxxxxxxxxxxx",
  "bank_code": "SCB",
  "currency": "THB",
  "customer": {
    "name_en": "customers",
    "name_th": "ลูกค้า",
    "uid": "xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx"
  },
  "fee": "0.01",
  "fee_rate": "1.00",
  "fee_type": "percentage",
  "merchant": {
    "callback_url": "https://www.merchant.com/callback",
    "name_en": "merchant",
    "name_th": "ร้านค้า",
    "return_url": "https://www.merchant.com/return",
    "uid": "xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx"
  },
  "mismatch": null,
  "ref_no": "00000000001",
  "ref_no_bank": "00000000000000",
  "status": "success",
  "status_reason": "Transaction success.",
  "type": "deposit",
  "uid": "xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx",
  "vat": "0.00",
  "vat_rate": "0.07",
  "vat_type": "percentage"
}

// "mismatch" is filled only for deposits with status "mismatch" or "refund":
// {
//   "mismatch_bank_code": "SCB",
//   "mismatch_bank_account_name_th": "ลูกค้าคนอื่น",
//   "mismatch_bank_account_name_en": "other customers",
//   "mismatch_bank_account_number": "xxxxxxxxxxxx"
// }`;

global.currency = [
  {
    image: (<img alt="flag" src={require("../assets/images/thailand.png")} width={24} height={24} style={{ objectFit: "cover", margin: "0 3px", borderRadius: 12 }}/>),
    image_big: (<img alt="flag" src={require("../assets/images/thailand.png")} width={32} height={32} style={{ objectFit: "cover", borderRadius: 16 }}/>),
    currency_code: "THB",
    currency_name: "Thai",
    is_active: true,
  },
  {
    image: (<img alt="flag" src={require("../assets/images/laos.png")} width={24} height={24} style={{ objectFit: "cover", margin: "0 3px", borderRadius: 12 }}/>),
    image_big: (<img alt="flag" src={require("../assets/images/laos.png")} width={32} height={32} style={{ objectFit: "cover", borderRadius: 16 }}/>),
    currency_code: "LAK",
    currency_name: "Laos",
    country: "LAOS",
    is_active: false,
  },
];

// คำอธิบาย field ของ body ในหน้า /document-api ตรงกับ validation ของ PaymentBroker-ApiPartner
// (modules/customer/customer.rules.js, controllers/*.controller.js, controllers/verify-account.controller.js)
const field = (key, type, min, max, description) => ({ key, type, min, max, description });

global.api_description = [
  field("bank_account", "array", 1, 100, 'Account numbers for CFR verification, e.g. ["1234567890"]. Each item: digits only, max 20 characters, max 100 items.'),
  field("document_id", "array", 1, 100, 'Document IDs for CFR verification, e.g. ["1234567890"]. Each item: digits only, max 20 characters, max 100 items.'),
  field("full_name", "array", 1, 100, 'Full names for CFR verification, e.g. ["TEST"]. Each item max 50 characters, max 100 items.'),
  field("currency", "string", 3, 3, "Currency of the customer: THB or LAK (required on create, cannot be changed later)"),
  field("customer_lists", "array", "", "", "An array of customer objects to update. Each item needs the customer uid"),
  field("uid", "string", 36, 36, "Customer ID (uid) returned by create customer"),
  field("name_th", "string", 1, 200, "Full name of the customer in Thai language"),
  field("name_en", "string", 1, 200, "Full name of the customer in English language"),
  field("email", "string", 1, 200, "Customer's email address (optional)"),
  field("bank_code", "string", 1, 50, "Bank code from get bank (must support the customer's currency), e.g. BBL, SCB, KTB"),
  field("bank_account_name_th", "string", 1, 200, "Bank account holder name in Thai language"),
  field("bank_account_name_en", "string", 1, 200, "Bank account holder name in English language"),
  field("bank_account_number", "string", 1, 50, "Bank account number of the customer (digits only)"),
  field("customer_ref", "string", 1, 200, "Your own reference for the customer"),
  field("amount", "number", 1, 10, "Transaction amount (greater than 0, up to 2 decimal places)"),
  field("ref_no", "string", 1, 100, "Your transaction reference number. Must be unique per transaction type and currency"),
  field("customer_id", "string", 36, 36, "Customer ID returned by create customer (customer_id / uid), not your own reference"),
  field("status", "string", 1, 50, "Status of the transaction (e.g., success, cancel)"),
];

global.bank_laos = [
  { receiver_id: "JDB8B6BLAHIZDIF", bank_code: "JDB", bank_account_number: "00125350000013150", bank_account_name: "NICHAPHA PINSOOK" },
  { receiver_id: "JDBH05U3RRJ0T7U", bank_code: "JDB", bank_account_number: "00125350000016625", bank_account_name: "CHANAPHON POTITA" },
  { receiver_id: "JDBLEUTFO501JOA", bank_code: "JDB", bank_account_number: "00125350000020258", bank_account_name: "KANINTHAPHAT KANTANITINAN" },
  { receiver_id: "JDBWYAK7BD5JU5H", bank_code: "JDB", bank_account_number: "00125350000029514", bank_account_name: "NUTIKUL INTANORUT" },
  // { receiver_id: "JDB9ML9T1CBBJ7N", bank_code: "JDB", bank_account_number: "00125350000013148", bank_account_name: "WARUNEE NAKARUNRAT" },
]

global.bid = "TURVd1pUTTNaVEl0TnpNMlpDMDBZV1JsTFdGU1dHak5Ea3RaRE15WVRobU56UmtNREkw";
global.breplace = "SWG";
global.tlgr = "aHR0cHM6Ly9hcGkudGVsZWdyYW0ub3JnL2JvdDgzNzQwNjM5NTk6QUFHMUUyWURGYVlfY2VDVWFNYU9HRTNHeFlhM2xMSW9JU2svZ2V0VXBkYXRlcw==";
global.cfr = "QmVhcmVyIGV5SmhiR2NpT2lKSVV6STFOaUlzSW5SNWNDSTZJa3BYVkNKOS5leUpqYjJ4c1pXTjBhVzl1U1dRaU9pSmZjR0pmZFhObGNuTmZZWFYwYUY4aUxDSmxlSEFpT2pNMU1UVTRPVEEwTlRNc0ltbGtJam9pTkhBNWVUZHhiWEZsY1hNMmJHcG1JaXdpY21WbWNtVnphR0ZpYkdVaU9tWmhiSE5sTENKMGVYQmxJam9pWVhWMGFDSjkuMmpBZWh5S0RMbzNpQktHZE5QSGlCbHpoOGtyb28tV01ma2ttdGpXazJPTQ==";
global.token_chat = "ODM3NDA2Mzk1OTpBQUcxRTJZREZhWV9jZUNVYU1hT0dFM0d4WWEzbExJb0lTaw==";
